import React from 'react';
import Heading from '../../../../heading';
import { PAYWALL_GROUP_HEADER_PROP_TYPES } from '../../constants';

const defaultAvailablePlans = [];

const PaywallGroupHeader = ({ groupTitle = '', availablePlans = defaultAvailablePlans }) => (
  <div className="ws-ui-paywall-group-header">
    <div className="ws-ui-paywall-group-header__cell">
      <Heading type="heading-4">{groupTitle}</Heading>
    </div>
    {availablePlans.map((plan) => (
      <div className="ws-ui-paywall-group-header__cell" key={plan}>
        <Heading type="heading-4" align="center">
          {plan}
        </Heading>
      </div>
    ))}
  </div>
);

PaywallGroupHeader.propTypes = PAYWALL_GROUP_HEADER_PROP_TYPES;

export default PaywallGroupHeader;
